enum ImageSize {
  Original = 'original',
  X50 = '50x50',
  X100 = '100x100',
  X150 = '150x150',
  X200 = '200x200',
  X300 = '300x300',
  X400 = '400x400',
  X500 = '500x500',
  X600 = '600x600',
  X800 = '800x800',
  X1000 = '1000x1000',
  X1200 = '1200x1200',
}

export default ImageSize
